import React, { useState } from "react";
import { Form, FormGroup, Label, Input, Button } from "reactstrap";
import { FaStar } from "react-icons/fa";
import axios from "axios";
import swal from "sweetalert2";
import { createReview } from "../../api/Reviews/reviewApi";
const ReviewForm = ({ userId, reviewType, productId }) => {
  const [formData, setFormData] = useState({
    review: "",
    rating: 0,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleRatingChange = (rating) => {
    setFormData((prevData) => ({
      ...prevData,
      rating,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Prepare data to send to the backend
    const reviewData = {
      userId: userId,
      reviewType: reviewType,
      productId: productId,
      review: formData.review,
      rating: formData.rating,
      subject: "Positive feedbackdf",
    };

    console.log("Review Data:", reviewData);

    try {
      await createReview(reviewData);
      // Show success message with SweetAlert2
      await swal.fire({
        icon: "success",
        title: "Success!",
        text: "Your review has been submitted successfully.",
        confirmButtonText: "OK",
      });
      // Reset form after successful submission
      setFormData({ review: "", rating: 0 });
    } catch (error) {
      // Handle errors (e.g., network issues or server errors)
      await swal.fire({
        icon: "error",
        title: "Error!",
        text: "There was an issue submitting your review. Please try again.",
        confirmButtonText: "OK",
      });
      console.error("Error submitting review:", error);
    }
  };

  return (
    <Form onSubmit={handleSubmit} className="max-w-md mx-auto">
      <FormGroup>
        <Label for="review">Review</Label>
        <Input
          type="textarea"
          name="review"
          value={formData.review}
          onChange={handleChange}
          placeholder="Review"
          className="border rounded-lg bg-light focus:outline-none h-32"
          required
        />
      </FormGroup>
      <FormGroup className="mt-3 d-flex">
        <div className="d-flex">
          {[1, 2, 3, 4, 5].map((star) => (
            <FaStar
              key={star}
              size={14}
              color={star <= formData.rating ? "#ffc107" : "#e4e5e9"}
              style={{ cursor: "pointer", marginRight: "5px" }}
              onClick={() => handleRatingChange(star)}
            />
          ))}
        </div>
      </FormGroup>
      <Button color="dark" className="mt-3 w-100 rounded-pill" type="submit">
        Submit Review
      </Button>
    </Form>
  );
};

export default ReviewForm;
